module.exports = __webpack_public_path__ + "static/media/clear-glass.5b532ac8.jpg";